import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
    EnumContractEnterpriseStatus,
    EnumContractStatus,
    EnumContractUserRole,
    EnumContractUserStatus,
    EnumSignMethod
} from 'src/app/core/constants/contract';

@Component({
    selector: 'app-contract-sign-status',
    templateUrl: './contract-sign-status.component.html',
    styleUrls: ['./contract-sign-status.component.scss']
})
export class ContractSignStatusComponent implements OnChanges {
    @Input() contractSignStatus: any[] = [];
    @Input() contractStatus: any;

    mapOfExpandData: { [key: string]: boolean } = {};
    dataSource: any[] = [];

    enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
    enumContractStatus = EnumContractStatus;
    enumContractUserRole = EnumContractUserRole;
    enumContractUserStatus = EnumContractUserStatus;
    enumSignMethod = EnumSignMethod;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.contractSignStatus) {
            this.dataSource = this.normalizeContractSignStatus(this.contractSignStatus);
            this.mapOfExpandData = {};
        }
    }

    getPartyKey(item: any, index: number): string {
        return `party-${item.enterpriseId || item.customerId || index}`;
    }

    getUserKey(item: any, index: number): string {
        return `user-${index}`;
    }

    getPartyName(party: any): string {
        return party.name || party.enterpriseName || '';
    }

    getUserName(user: any): string {
        return user.name || user.userName || '';
    }

    getContactEmail(item: any): string {
        return item.email || item.userEmail || '';
    }

    getContactPhone(item: any): string {
        return item.phone || item.userPhone || '';
    }

    getUsersByParty(party: any): any[] {
        return Array.isArray(party.userSignsStatus) ? party.userSignsStatus : [];
    }

    isStoppedDocument(): boolean {
        return this.contractStatus === this.enumContractStatus.REJECTED
            || this.contractStatus === this.enumContractStatus.CANCELLED;
    }

    isProcessingEnterprise(status: number): boolean {
        return status === this.enumContractEnterpriseStatus.PROCESSING
            || status === this.enumContractEnterpriseStatus.WAIT_SETUP_FLOW;
    }

    isProcessingUser(status: number): boolean {
        return status === this.enumContractUserStatus.PROCESSING
            || status === this.enumContractUserStatus.DAEMON_PROCESSING;
    }

    getRoleLabelKey(role: any): string {
        if (role == this.enumContractUserRole.CANCEL) {
            return 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_cancel';
        }

        if (role == this.enumContractUserRole.SIGN || role == 6) {
            return 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_sign';
        }

        return 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_approve';
    }

    private normalizeContractSignStatus(contractSignStatus: any[]): any[] {
        if (!Array.isArray(contractSignStatus)) {
            return [];
        }

        return contractSignStatus
            .map(item => ({
                ...item,
                userSignsStatus: this.sortByOrder(item.userSignsStatus)
            }))
            .sort((a, b) => Number(a.order || 0) - Number(b.order || 0));
    }

    private sortByOrder(items: any): any[] {
        if (!Array.isArray(items)) {
            return [];
        }

        return [...items].sort((a, b) => Number(a.order || 0) - Number(b.order || 0));
    }
}
